import { Modal } from "@heroui/react";
import { ModalContext } from "./ModalContext";
import { ReactNode, useState } from "react";

type ModalInstance = {
	id: string;
	render: () => ReactNode;
};

export function ModalContainer({ children }: { children: ReactNode }) {
	const [modals, setModals] = useState<ModalInstance[]>([]);

	const open = (render: () => ReactNode) => {
		const id = crypto.randomUUID(); // or use your own ID generator
		setModals((prev) => [...prev, { id, render }]);
		return id;
	};

	const close = (id: string) => {
		setModals((prev) => prev.filter((modal) => modal.id !== id));
	};

	return (
		<ModalContext.Provider value={{ open, close }}>
			{modals.map((modal) => (
				<Modal key={modal.id} isOpen={true} onOpenChange={() => close(modal.id)}>
					{modal.render()}
				</Modal>
			))}

			{children}
		</ModalContext.Provider>
	);
}
